import { render, staticRenderFns } from "./ModalDeclaracaoJurada.vue?vue&type=template&id=7467a7ac&lang=pug"
import script from "./ModalDeclaracaoJurada.vue?vue&type=script&lang=js"
export * from "./ModalDeclaracaoJurada.vue?vue&type=script&lang=js"
import style0 from "./ModalDeclaracaoJurada.vue?vue&type=style&index=0&id=7467a7ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports